import { render } from "./CartView.vue?vue&type=template&id=6554fb84&scoped=true"
import script from "./CartView.vue?vue&type=script&lang=js"
export * from "./CartView.vue?vue&type=script&lang=js"

import "./CartView.vue?vue&type=style&index=0&id=6554fb84&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6554fb84"]])

export default __exports__